<div class="tiles">
  <section class="tile tile-completion" aria-labelledby="cxp-crl-completion-title">
    <div class="completion-head">
      <h2 id="cxp-crl-completion-title" class="tile-label">Overall Completion Status</h2>
      <span class="completion-percent">{{ progress().percent }}%</span>
    </div>

    <mat-progress-bar
      class="completion-bar"
      mode="determinate"
      [value]="progress().percent"
      [dataSelector]="'cxp-crl-progress-bar'"
    ></mat-progress-bar>

    @if (isNotStarted()) {
      <p class="completion-sub">Not started yet. Contact us if you have questions.</p>
    } @else {
      <p class="completion-sub">
        {{ stateLabel() }} — <span class="completion-count">{{ progress().done }} of {{ progress().total }}</span> requests done
      </p>
    }
  </section>

  <button
    type="button"
    class="tile tile-metric"
    aria-label="Filter by Waiting for You"
    [class.tile-metric-active]="isTileActive(filterKey.waitingForYou)"
    [attr.aria-pressed]="isTileActive(filterKey.waitingForYou)"
    [dataSelector]="'cxp-crl-tile-waiting'"
    (click)="onTileToggled(filterKey.waitingForYou)"
  >
    <span class="metric-label">Waiting for You</span>
    <div class="metric-value-row">
      <span class="metric-value">{{ tiles().waitingForYou }}</span>
      @if (tiles().overdue > 0) {
        <pill size="medium" color="red" [value]="tiles().overdue + ' Overdue'" [dataSelector]="'cxp-crl-tile-overdue'"></pill>
      }
    </div>
  </button>

  @if (isInReviewEnabled) {
    <button
      type="button"
      class="tile tile-metric"
      aria-label="Filter by In Review"
      [class.tile-metric-active]="isTileActive(filterKey.inReview)"
      [attr.aria-pressed]="isTileActive(filterKey.inReview)"
      [dataSelector]="'cxp-crl-tile-in-review'"
      (click)="onTileToggled(filterKey.inReview)"
    >
      <span class="metric-label">In Review</span>
      <div class="metric-value-row">
        <span class="metric-value">{{ tiles().inReview }}</span>
      </div>
    </button>
  }

  <button
    type="button"
    class="tile tile-metric"
    aria-label="Filter by Needs Update"
    [class.tile-metric-active]="isTileActive(filterKey.needsUpdate)"
    [attr.aria-pressed]="isTileActive(filterKey.needsUpdate)"
    [dataSelector]="'cxp-crl-tile-needs-update'"
    (click)="onTileToggled(filterKey.needsUpdate)"
  >
    <span class="metric-label">Needs Update</span>
    <div class="metric-value-row">
      <span class="metric-value">{{ tiles().needsUpdate }}</span>
    </div>
  </button>
</div>
